import React, { useContext } from "react";
import { DataPropsContext } from "../../foundation/Contexts/DataPropsContext";
import UserProfilePostsTimeline from "./UserProfilePostsTimeline";

export default function UserPostForProfile({
  profileUserId
}: {
  profileUserId: string;
}) {
  const dataProps = useContext(DataPropsContext);
  const currentUserId = dataProps?.currentUserId;
  return (
    <div>
      {currentUserId && (
        <div style={{ width: "100%" }}>
          <UserProfilePostsTimeline profileUserId={profileUserId} />
        </div>
      )}
    </div>
  );
}
